import { View } from 'react-big-calendar';
import { create } from 'zustand';

export const useCalendarDetailStore = create<{
  visible: boolean;
  curItem?: any;
  reset: () => void;
  setVisible: (value: boolean) => void;
  setCurItem: (value?: any) => void;
}>((set) => ({
  visible: false,
  curItem: undefined,
  setVisible: (value) => set(() => ({ visible: value })),
  setCurItem: (value) => set(() => ({ curItem: value })),
  reset: () => set(() => ({ visible: false, curItem: undefined })),
}));

export const useCalendarViewTypeStore = create<{ type: View; setType: (type: View) => void }>(
  (set) => ({
    type: 'month',
    setType: (type) => set(() => ({ type: type })),
  }),
);

export const useSelectedDateStore = create<{ date: Date; setDate: (date: Date) => void }>(
  (set) => ({
    date: new Date(),
    setDate: (selectedDate) => set(() => ({ date: selectedDate })),
  }),
);
